import React,{useState} from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  InputGroup,
} from 'react-bootstrap';
import { FaSearch, FaMapMarkerAlt } from 'react-icons/fa';
import { FiSearch } from "react-icons/fi";
import styles from "./Search.module.css"
import ServiceCard from '../layout/ServiceCard/ServiceCard';

export default function Search() {
  const [price, setPrice] = useState(50);
   const [active, setActive] = useState('All');
const categories = [
  'All',
  'Kitchen',
  'Bathroom',
  'Living Room',
  'Bedroom',
  'Garage',
  'Balcony',
  'Dining Room',
  'Office',
  'Laundry Room',
  'Closet',
  'Basement',
  'Attic',
  'Stairs',
  'Entryway',
  'Windows',
  'Floors',
  'Walls',
  'Carpet',
  'Furniture',
  'Appliances',
  'Outdoor',
  'Garden',
  'Pet Area',
  'Playroom',
];

const services = [
  {
    image: 'https://img.freepik.com/free-photo/medium-shot-woman-cleaning-home_23-2150453302.jpg?semt=ais_hybrid&w=740',
    title: 'Kitchen Cleaning',
    description: 'Deep clean of counters, stove, sink, and appliances.',
  },
  {
    image: 'https://media.istockphoto.com/id/1207800619/photo/young-woman-doing-household-chores-cleaning-bathroom-tub.jpg?s=612x612&w=0&k=20&c=CfYI1U4Zs1c0lPgi-0AQJxiBErucyV4_66LtL-JF7xs=',
    title: 'Bathroom Cleaning',
    description: 'Sanitize toilet, shower, mirror, and floor.',
  },
  {
    image: 'https://cdn.shopify.com/s/files/1/0669/1684/3771/files/Cleaning-Your-Living-Room.jpg',
    title: 'Living Room',
    description: 'Dusting, vacuuming, and organizing the living space.',
  },
  {
    image: 'https://img.freepik.com/free-photo/medium-shot-woman-cleaning-home_23-2150453302.jpg?semt=ais_hybrid&w=740',
    title: 'Kitchen Cleaning',
    description: 'Deep clean of counters, stove, sink, and appliances.',
  },
  {
    image: 'https://media.istockphoto.com/id/1207800619/photo/young-woman-doing-household-chores-cleaning-bathroom-tub.jpg?s=612x612&w=0&k=20&c=CfYI1U4Zs1c0lPgi-0AQJxiBErucyV4_66LtL-JF7xs=',
    title: 'Bathroom Cleaning',
    description: 'Sanitize toilet, shower, mirror, and floor.',
  },
  {
    image: 'https://cdn.shopify.com/s/files/1/0669/1684/3771/files/Cleaning-Your-Living-Room.jpg',
    title: 'Living Room',
    description: 'Dusting, vacuuming, and organizing the living space.',
  },
  {
    image: 'https://img.freepik.com/free-photo/medium-shot-woman-cleaning-home_23-2150453302.jpg?semt=ais_hybrid&w=740',
    title: 'Kitchen Cleaning',
    description: 'Deep clean of counters, stove, sink, and appliances.',
  },
  {
    image: 'https://media.istockphoto.com/id/1207800619/photo/young-woman-doing-household-chores-cleaning-bathroom-tub.jpg?s=612x612&w=0&k=20&c=CfYI1U4Zs1c0lPgi-0AQJxiBErucyV4_66LtL-JF7xs=',
    title: 'Bathroom Cleaning',
    description: 'Sanitize toilet, shower, mirror, and floor.',
  },
  {
    image: 'https://cdn.shopify.com/s/files/1/0669/1684/3771/files/Cleaning-Your-Living-Room.jpg',
    title: 'Living Room',
    description: 'Dusting, vacuuming, and organizing the living space.',
  },
];
  return (
    <Container fluid className="bg-light py-5 min-vh-100">
      {/* Hero Section */}
      <Container className="text-center mb-5">
        <h1 className="display-5 fw-bold">Find Trusted House Services</h1>
        <p className="text-muted">
          Book cleaners, electricians, plumbers and more – all in one place.
        </p>
      </Container>
      <Container className="mb-4">
        <div className={styles.searchBox} >
          <div  className={styles.searchContainer} >
                  <FiSearch style={{marginLeft:10,color:"#777"}} size={20}/>
                  <input placeholder='Find your service' style={{width:"90%",marginLeft:12,border:"none",background:"transparent",outline:"none"}}/>
          </div>

        </div>
        <br/>
  <div className={styles.scrollContainer}>
      {categories.map((category) => (
        <button
          key={category}
          className={`${styles.categoryButton} ${active === category ? styles.active : ''}`}
          onClick={() => setActive(category)}
        >
          {category}
        </button>
      ))}
    </div>

    <div className={styles.serviceGrid}>
  {services.map((s, i) => (
    <ServiceCard key={i} {...s} />
  ))}
</div>

        {/* <Row className="g-3 justify-content-center">
          <Col xs={12} md={5}>
            <InputGroup>
              <InputGroup.Text>
                <FaSearch />
              </InputGroup.Text>
              <Form.Control placeholder="Search services (e.g., cleaner, plumber)" />
            </InputGroup>
          </Col>
       
          <Col xs={12} md="auto">
            <Button variant="primary" className="w-100">
              Search
            </Button>
          </Col>
        </Row> */}
      </Container>
      {/* <Container className="mb-5 text-center">
        <Form.Label> Price Range: ₹20 - ₹{price}</Form.Label>
          <Form.Range
          min={20}
          max={100}
          value={price}
          onChange={(e) => setPrice(e.target.value)}
        />
      </Container> */}
      {/* <Container>
        <Row className="g-4">
          {[...Array(6)].map((_, i) => (
            <Col key={i} xs={12} md={6} lg={4}>
              <Card className="h-100 shadow-sm">
                <Card.Body>
                  <Card.Title>SparkClean Home Cleaning</Card.Title>
                  <Card.Text>
                    Short description about the service provider and what they offer.
                  </Card.Text>
                  <h5 className="text-primary">₹50 / hour</h5>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container> */}
    </Container>
  );
}
